module.exports = __webpack_public_path__ + "img/voucher_icon_5.c5650d06.svg";